// client/src/routes/_auth/reset-password.$token.tsx — SCR-AUTH-005, second half · AUTH-004.
//
// The token in the path is the sealed value from the e-mail (`PasswordResetTokens.cs`); the
// SPA never opens it, only hands it back. No session guard: a signed-in user who clicked a
// reset link still meant to reset their password.

import { createFileRoute } from '@tanstack/react-router';

import { ResetPasswordForm } from '@/features/auth/ResetPasswordForm';

export const Route = createFileRoute('/_auth/reset-password/$token')({
  component: ResetPasswordScreen,
});

function ResetPasswordScreen() {
  const { token } = Route.useParams();
  return <ResetPasswordForm token={token} />;
}
